import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { DiffsFormData, DiffsFormSchema } from '@screens/players/player.details.tabs/diffs/diffs.form.data';

const columns = [
  { field: 'datee', headerName: 'Timestamp', ...formatColWithDate, width: 165 },
  { field: 'roundId', headerName: 'RoundId', width: 170 },
  { field: 'action', headerName: 'Action', width: 235 },
  { field: 'remoteG', headerName: 'RCash', width: 155 },
  { field: 'greens', headerName: 'Cash', width: 155 },
  { field: 'remoteC', headerName: 'RCoins', width: 155 },
  { field: 'chips', headerName: 'Coins', width: 155 },
];

interface DiffsInfos {
  id: number;
  datee: string;
  roundId: number;
  action: string;
  remoteG: number;
  greens: number;
  remoteC: number;
  chips: number;
}

const PlayerDiffsList = (props: DiffsFormData) => {
  const { authorizedServices } = useAuth();

  async function runSearch(data: DiffsFormData, page: number, cancelToken: CancelToken | undefined) {
    if (!data) throw new Error('Insert at least one field');
    await DiffsFormSchema.validate(data, { abortEarly: false });
    return authorizedServices.get<DiffsInfos[]>(`/admin/diffs/player/${data.pid}`, { params: { ...data, page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(props, runSearch, {
    placeholderData: noopArray,
  });
  // const rows = responseData?.map(createData) || [];
  const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PlayerDiffsList;
